// LUMINA · pages/vajra/components/MyCredentials.jsx
// Phase 39D: extracted from VajraPortal.jsx

import React, { useState, useEffect } from 'react';
import { API, GDL, TXT, TXT2 } from '../constants';

export default function MyCredentials({ token }) {
  const [creds, setCreds] = useState([]);
  const [teachings, setTeachings] = useState([]);
  const [loaded, setLoaded] = useState(false);
  useEffect(()=>{
    Promise.all([
      fetch(`${API}/vajra/me/credentials`,{headers:{"Authorization":`Bearer ${token}`}})
        .then(r=>r.ok?r.json():{credentials:[]}).then(d=>d.credentials||[]),
      fetch(`${API}/vajra/teachings`).then(r=>r.ok?r.json():[]).catch(()=>[]),
    ]).then(([cr, te])=>{ setCreds(cr); setTeachings(te); setLoaded(true); });
  },[token]);

  const TYPE_COLOR = {empowerment:"#7c3aed", in_progress:"#d97706", completed:"#065f46"};
  const TYPE_LABEL = {empowerment:"灌顶", in_progress:"修习中", completed:"已圆满"};
  const getTeaching = (c) => teachings.find(t => t.credential_key && t.credential_key === c.credential_key) || null;

  if (!loaded) return <div style={{fontSize:12,color:"#aaa",padding:"12px 0"}}>加载中…</div>;

  return (
    <div style={{
      background:"rgba(255,255,255,0.4)", border:"1px solid rgba(0,0,0,0.06)",
      borderRadius:12, padding:20, marginTop:16,
    }}>
      <div style={{fontSize:11, color:"#aaa", letterSpacing:2, textTransform:"uppercase", marginBottom:14}}>
        修行资质档案
      </div>
      {creds.length === 0 ? (
        <div style={{fontSize:12, color:"#bbb", padding:"8px 0"}}>暂无资质记录</div>
      ) : (
        <div style={{display:"flex", flexDirection:"column", gap:10}}>
          {creds.map(c=>{
            const teaching = getTeaching(c);
            return (
              <div key={c.id} style={{padding:"10px 12px",borderRadius:9,
                background:"rgba(255,255,255,0.7)",border:"1px solid rgba(212,175,55,0.12)"}}>
                <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:teaching?6:0}}>
                  <span style={{
                    fontSize:11, fontWeight:700, color:TYPE_COLOR[c.credential_type]||"#888",
                    background:`${TYPE_COLOR[c.credential_type]}18`, padding:"2px 8px",
                    borderRadius:4, minWidth:48, textAlign:"center", flexShrink:0,
                  }}>
                    {TYPE_LABEL[c.credential_type]||c.credential_type}
                  </span>
                  <span style={{fontSize:13, color:TXT, flex:1, fontWeight:500}}>{c.label_zh||c.credential_key}</span>
                  <span style={{fontSize:11, color:"#bbb", flexShrink:0}}>{c.granted_at?.slice(0,10)||""}</span>
                </div>
                {teaching && (
                  <div style={{paddingLeft:62,fontSize:12,color:TXT2,display:"flex",gap:6,flexWrap:"wrap"}}>
                    {teaching.teacher_name&&<span style={{background:"rgba(212,175,55,0.08)",border:"1px solid rgba(212,175,55,0.2)",borderRadius:6,padding:"1px 7px"}}>{teaching.teacher_name}</span>}
                    {teaching.tradition&&<span style={{background:"rgba(5,150,105,0.06)",border:"1px solid rgba(5,150,105,0.2)",borderRadius:6,padding:"1px 7px"}}>{teaching.tradition}</span>}
                    {teaching.lineage&&<span style={{background:"rgba(139,105,20,0.06)",border:"1px solid rgba(139,105,20,0.18)",borderRadius:6,padding:"1px 7px"}}>{teaching.lineage}</span>}
                  </div>
                )}
                {teaching?.description_zh && (
                  <div style={{paddingLeft:62,fontSize:11,color:"#999",marginTop:3,lineHeight:1.5,
                    overflow:"hidden",display:"-webkit-box",WebkitLineClamp:2,WebkitBoxOrient:"vertical"}}>
                    {teaching.description_zh}
                  </div>
                )}
                {teaching?.stages?.length > 0 && (
                  <div style={{marginTop:10,paddingTop:10,borderTop:"1px solid rgba(212,175,55,0.1)"}}>
                    <div style={{fontSize:10,color:GDL,letterSpacing:1.2,textTransform:"uppercase",marginBottom:6}}>修行路径</div>
                    {teaching.stages.map((stage,si)=>{
                      const done = creds.find(cr=>cr.credential_key===stage.credential_key);
                      return (
                        <div key={stage.id} style={{display:"flex",alignItems:"center",gap:8,padding:"3px 0",fontSize:12}}>
                          <span style={{color:done?"#059669":"#ccc",fontSize:13,flexShrink:0}}>{done?"✅":"⬜"}</span>
                          <span style={{fontSize:11,color:TXT2,minWidth:18}}>{"①②③④⑤⑥⑦⑧⑨⑩"[si]||si+1}</span>
                          <span style={{flex:1,color:done?TXT:TXT2,fontWeight:done?500:400}}>{stage.name_zh}</span>
                          {done&&<span style={{fontSize:10,color:"#aaa",flexShrink:0}}>{done.granted_at?.slice(0,10)||""}</span>}
                          {!done&&stage.is_required&&<span style={{fontSize:10,color:"#ccc",flexShrink:0}}>未完成</span>}
                        </div>
                      );
                    })}
                    {(()=>{
                      const req = teaching.stages.filter(s=>s.is_required);
                      if(!req.length) return null;
                      const done = req.filter(s=>creds.find(c=>c.credential_key===s.credential_key)).length;
                      const pct = Math.round(done/req.length*100);
                      return (
                        <div style={{marginTop:8}}>
                          <div style={{fontSize:10,color:"#aaa",marginBottom:3}}>进度 {done}/{req.length} · {pct}%</div>
                          <div style={{height:4,borderRadius:2,background:"rgba(0,0,0,0.06)"}}>
                            <div style={{height:"100%",width:`${pct}%`,borderRadius:2,
                              background:"linear-gradient(90deg,#D4AF37,#8B6914)",transition:"width .4s"}}/>
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
